import axios from 'axios';
import {AlertService} from '../../service/alert.service';
import {KRBS_TONS} from '../../config/constanst.config';
import {AppService} from '../../service/app.service';

/** state **/
const state = {
  vessel: {},
  vessels: [],
  formVesselData: {
    searchVal: null,
    vesselType: null,
    count: 10,
    page: 1,
  },
  vesselDetails: {},
  vesselTonRanks: [],
};

/** mutations **/
const mutations = {
  set_vessel(state, payload) {
    state.vessel = payload;
  },

  set_vessels(state, payload) {
    state.vessels = payload;
  },

  set_vessel_details(state, payload) {
    state.vesselDetails = payload;
  },

  set_vessel_ton_ranks(state, payload) {
    state.vesselTonRanks = payload;
  },

  reset_vessel(state) {
    state.vessel = {};
  },

  reset_vessels(state) {
    state.vessels = [];
  },

  reset_form_data(state) {
    state.formVesselData = {
      searchVal: null,
      vesselType: null,
      count: 10,
      page: 1,
    };
  },

  reset_vessel_details(state) {
    state.vesselDetails = {};
  },

  reset_vessel_ton_ranks(state) {
    state.vesselTonRanks = [];
  },
};

/** actions **/
const actions = {
  async getVesselPaginated({commit}, payload) {
    commit('set_is_loading', true);
    return await axios.post(KRBS_TONS.STAFF_GET_VESSEL_PAGINATED, payload).then((r) => {
      let vesselPaginated = r.data.vesselPaginated?.data;
      let vesselTypes = r.data.vesselTypes;

      commit('set_is_loading', false);
      commit('set_vessel_paginated', r.data.vesselPaginated);
      commit('set_vessels', vesselPaginated);
      commit('set_vessel_type_keys', vesselTypes);
      return true;

    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'Vessel Paginated');
      return false;

    });
  },

  getVesselTonRanks({commit}, params) {
    commit('set_is_loading', true);
    return axios.get(`${KRBS_TONS.STAFF_GET_VESSEL_TON_RANKS}/${params}`).then((r) => {
      commit('set_is_loading', false);
      commit('set_rank_keys', r.data.rankKeys);
      commit('set_vessel_details', r.data.vesselDetails);
      commit('set_vessel_ton_ranks', r.data.vesselTonRanks);
      return true;
    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'Get Vessel Details');
      return false;
    });
  },

  updateVesselTonRanks({commit},payload){
    return axios.post(`${KRBS_TONS.STAFF_UPDATE_VESSEL_TON_RANKS}/${payload.vesselId}`,payload).then((r)=>{
      commit('set_vessel_ton_ranks',r.data)
      return true;
    }).catch((er)=>{
      // console.log(er.response)
      AlertService.responseAlertMessage(er,'Update vessel ton ranks')
      return false;
    })
  },

  set_vessel_ton_ranks({commit},payload){
    commit('set_vessel_ton_ranks',payload)
  },

  reset_vessel({commit}) {
    commit('reset_vessel');
  },

  resetVessels({commit}) {
    commit('reset_vessels');
  },

  reset_form_data({commit}) {
    commit('reset_form_data');
  },

  reset_vessel_details({commit}) {
    commit('reset_vessel_details')
  },
  reset_vessel_ton_ranks({commit}) {
    commit('reset_vessel_ton_ranks')
  }
};

/** getters **/
const getters = {
  vessel: state => state.vessel,
  vessels: state => state.vessels,
  formVesselData: state => state.formVesselData,
  vesselDetails: state => state.vesselDetails,
  vesselTonRanks: state => state.vesselTonRanks,
};

/** export **/
export default {state, actions, mutations, getters};
